/* globals $,Raven,escape,unescape */

const { getAllAllowedTermsMap, getAllowedTermsArray, getClosestAllowedTerm } = require('../terms');

/*
*
* GLOBAL VARIABLES
*/
window.loanAmountMin = 100;
window.loanAmountMax = 10000;
var cookieName = 'vm2023';
var expirySeconds = 3600;
window.totalRepayable;
window.totalInterest;
window.monthlyPaymentTwoDecimals;
var warningBox = $('#warning_box');
var isMobile = window.matchMedia("only screen and (max-width: 991px)").matches;
var setDefaultNavMenu = true;
window.dataLayer = window.dataLayer || [];

require('./../external-scripts/digi-picker');
require('./../external-scripts/bootstrap.min');
require("velocity-animate");
require("velocity-animate/velocity.ui");

Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

function unformatCurrency(x) {
    var y = x.replace(/,/g, '');
    var q = y.replace(/,/, '');
    var z = q.replace(/£/, '');
    return z;
}

function lockButton(term) {
    var el = $(".term-button[data-value='" + term + "']");
    $(el).addClass('term-btn-locked');
    // $(el).find('.text').text("N/A");
    //$(el).find('p').addClass('locked-text');
}

function unlockButton(term) {
    var el = $(".term-button[data-value='" + term + "']");
    $(el).removeClass('term-btn-locked');
}

function setButtonVisibility(term, shown) {
    var el = $(".term-button[data-value='" + term + "']");
    $(el).toggleClass('term-btn-hidden', !shown);
}

function pmt(ir, np, pv, fv, type) {
    var pmt, pvif;
    fv || (fv = 0);
    type || (type = 0);
    if (ir === 0)
        return -(pv + fv) / np;
    pvif = Math.pow(1 + ir, np);
    pmt = -ir * pv * (pvif + fv) / (pvif - 1);
    if (type === 1)
        pmt /= (1 + ir);
    return pmt;
}

function handleTermOrAmountValues(termLength, loanAmount) {
    updateCookie(cookieName, 'la', loanAmount, expirySeconds);
    updateCookie(cookieName, 'trm', termLength, expirySeconds);
    $('.amount_header').html(withCommas(loanAmount));
    var termMap = getAllAllowedTermsMap(loanAmount);

    if ($('body').hasClass('restricted')) {
        var termVisibleMap = {
            3: false,
            6: false,
            12: true,
            18: true,
            24: true,
            36: true,
            48: true,
            60: true,
        }
    } else {
        var termVisibleMap = {
            3: loanAmount <= 2500,
            6: loanAmount <= 2500,
            12: true,
            18: true,
            24: true,
            36: true,
            48: loanAmount > 2500,
            60: loanAmount > 2500,
        };
    }

    Object.keys(termMap).forEach((item) => {
        termMap[item] ? unlockButton(item) : lockButton(item);
    });

    Object.keys(termVisibleMap).forEach((item) => {
        setButtonVisibility(item, termVisibleMap[item]);
    });

    var closestAllowedTerm = getClosestAllowedTerm(loanAmount, termLength);
    if (closestAllowedTerm && closestAllowedTerm != termLength) {
        $(".term-button[data-value='" + closestAllowedTerm + "']").click();
    }
}

function roundLoanAmount(amount) {
    if ($('body').is('.uk-personal-loans')) {
        var la = $('[name=cta-amount]');
    } else {
        var la = $('[name=loanamount]');
    }
    var previousVal = la.val();
    if (la.val() == '' && la.data('prev-val') != '' && typeof la.data('prev-val') !== 'undefined') {
        previousVal = la.data('prev-val');
        return previousVal;
    }
    var returnValue = Math.max(window.loanAmountMin, Math.min(window.loanAmountMax, Math.ceil(amount / 50) * 50));
    la.data('prev-val', returnValue);
    return returnValue;
}

function changeLoanAmount(element) {
    var $inputval = element.val();
    $inputval = roundLoanAmount(unformatCurrency($inputval));
    element.val($inputval);
    $('[name=loan_amount]').val($inputval);
    $('[name=loanamount]').val($inputval);
    //$('[name=loan_amount]').trigger("change");
    var slider = $('.slider-container').find('input[type=range]');
    if (slider.length === 1) {
        slider.val($inputval).change();
    }
}

function sendSentryBreadcrumb(data) {
    if (typeof Sentry !== 'undefined') {
        Sentry.addBreadcrumb(data);
    }
}

function withCommas(x) {
    x = x || '';
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

function setCookie(cname, cvalue, exseconds) {
    var d = new Date();
    d.setTime(d.getTime() + (exseconds * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + escape(cvalue) + "; " + expires + "; path=/";
}

function getCookie(c_name) {
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) {
        c_start = c_value.indexOf(c_name + "=");
    }
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unicodeToChar(unescape(c_value.substring(c_start, c_end)));
    }
    return c_value;
}

function delCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function unicodeToChar(text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function (match) {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
    });
}

function updateCookie($cookieName, $varName, $varValue, $expirySeconds) {
    var cookieData = JSON.parse(getCookie($cookieName));
    if (cookieData > '' && $varValue > '') {
        cookieData[$varName] = $varValue.toString();
    }
    var $cookieString = JSON.stringify(cookieData);
    setCookie($cookieName, $cookieString, $expirySeconds);
}

var formPageTermBlockout = function (form, value) {
    value = parseInt(value);
    // Block out terms if the value has invalidated the terms
    if ($('body').is('.uk-loan-purpose')) {
        var term = $('[name=cta-term]');
    } else {
        var term = form.find('[name=term]');
    }
    var options = term.find('option');
    var termVal = parseInt(term.val());
    var initialMap = (function () {
        var map = {};
        options.each(function (i, o) {
            var option = $(o);
            map[option.attr('value')] = option.prop('disabled');
        });
        return map;
    })();
    var rebuildJsDropDowns = false;
    var updateTerms = function (map) {
        if (map !== initialMap) {
            if (!$('body').is('.uk-loan-purpose')) {
                rebuildJsDropDowns = true;
            }
            var k;
            for (k in map) {
                if (map.hasOwnProperty(k)) {
                    options.filter('[value=' + k + ']').prop('disabled', map[k]);
                }
            }
        }
    };
    updateTerms(getAllAllowedTermsMap(value));
    if (value < 1000) {
        if (termVal >= 18) {
            // Change term to 12
            if ($('body').is('.uk-loan-purpose')) {
                term.val(12);
            } else {
                window.form.otfValidate(term.val(12));
                rebuildJsDropDowns = true;
            }
        }
    } else if (value === 1000) {
        if (termVal > 36) {
            // Change term to 12
            if ($('body').is('.uk-loan-purpose')) {
                term.val(36);
            } else {
                window.form.otfValidate(term.val(36));
                rebuildJsDropDowns = true;
            }
        }
    } else if (value > 1000 && value < 2000) {
        // Lock 3
        if (termVal == 3) {
            // Change term to 6
            if ($('body').is('.uk-loan-purpose')) {
                term.val(6);
            } else {
                window.form.otfValidate(term.val(6));
                rebuildJsDropDowns = true;
            }
        }
    } else if (value > 2500 && value < 7500) {
        // Lock 3
        if (termVal < 12) {
            // Change term to 6
            if ($('body').is('.uk-loan-purpose')) {
                term.val(12);
            } else {
                window.form.otfValidate(term.val(12));
                rebuildJsDropDowns = true;
            }
        }
    } else {
        if (termVal <= 12) {
            // Change term to 12
            if ($('body').is('.uk-loan-purpose')) {
                term.val(18);
            } else {
                window.form.otfValidate(term.val(18));
                rebuildJsDropDowns = true;
            }
        }
    }
    if (rebuildJsDropDowns === true) {
        if (window.innerWidth > 991) {
            // Select2
        } else {
            // Digi Picker
            term.picker('destroy');
            term.picker();
        }
    }
};

// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
    var opts = Object.defineProperty({}, 'passive', {
        get: function () {
            supportsPassive = true;
        }
    });
    window.addEventListener("test", null, opts);
} catch (e) { }

// Use our detect's results. passive applied if supported, capture will be false either way.
if (warningBox.length === 1) {
    var windowScrollHandler = function (event) {
        if (window.scrollY > 100 && window.warningBoxHidden !== true && warningBox.length === 1) {
            window.warningBoxHidden = true;
            warningBox.removeClass('in');
            try {
                window.removeEventListener('scroll', windowScrollHandler);
            } catch (e) { }
        }
    };
    window.addEventListener('scroll', windowScrollHandler, supportsPassive ? {
        passive: true
    } : false);
}

// Debouncer
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

var headerSection = $('#header-section');
var menuGuidesContainer = $('#menu-guides-container');
var menuOverlay = $('#menu-overlay');
var menuGuides = $('#menu-guides');
var colMenu = $('#menu-guides .col-menu');
var colSubMenu = $('#menu-guides .col-submenu');
var colMenuItem = $('#menu-guides .col-menu .menu-item');
var menuTextMobile = $('#menu-header-text');
var menuMobileBackButton = $('#top_menu_mobile_back_button');
var menuMobileLogo = $('#menu-site-logo');
if (headerSection.length === 1) {
    if (isMobile) {
        headerSection.addClass('mobile');
        $(document).on('click', '#top_menu_button', function (event) {
            showNavMenu();
        });
        $(document).on('click', '#menu-guides .col-menu .menu-item', function (event) {
            showNavSubMenu(this);
        });
        $(document).on('click', '#top_menu_exit_button', function (event) {
            hideNavMenus();
        });
        $(document).on('click', '#menu-header-text-container', function (event) {
            showNavMenu();
        });
    } else {
        headerSection.addClass('desktop');
        $(document).on('mouseenter', '#page_header ul.links li, #menu-overlay', function (event) {
            hideNavMenus();
        });
        $(document).on('mouseenter', '#page_header ul.links li#guides-link', function (event) {
            showNavMenu();
        });
        $(document).on('mouseenter', '#menu-guides .col-menu .menu-item', function (event) {
            showNavSubMenu(this);
        });
    }
}

function showNavMenu() {
    headerSection.addClass('open');
    menuGuidesContainer.removeClass('hidden');
    if (isMobile) {
        colSubMenu.addClass('hidden-sm hidden-xs');
        colMenu.removeClass('hidden');
        menuMobileBackButton.addClass('hidden');
        menuTextMobile.addClass('hidden');
        menuMobileLogo.removeClass('hidden');
        menuTextMobile.text('Menu');
        $('html, body').css('overflow', 'hidden').css('height', '100%');
    } else {
        menuOverlay.removeClass('hidden');
        // Set default nav menu on desktop
        if (setDefaultNavMenu) {
            menuGuides.find('.col-menu .menu-item:nth-of-type(1)').addClass('active');
            menuGuides.find('.col-submenu .submenu:nth-of-type(1)').removeClass('hidden');
            setDefaultNavMenu = false;
        }
    }
    setTimeout(function () {
        menuGuidesContainer.addClass('in');
        if (!isMobile) {
            menuOverlay.addClass('in');
        }
    }, 10);
}

function showNavSubMenu(menuElement) {
    var menuItemIndex = $(menuElement).index() + 1;
    var menuItemTitle = $(menuElement).text();
    if (isMobile) {
        colMenu.addClass('hidden');
        menuTextMobile.text(menuItemTitle);
        menuTextMobile.removeClass('hidden');
        menuMobileBackButton.removeClass('hidden');
        menuMobileLogo.addClass('hidden');
    } else {
        colMenuItem.removeClass('active');
        $(menuElement).addClass('active');
    }
    colSubMenu.removeClass('hidden-sm hidden-xs');
    colSubMenu.find('.submenu').addClass('hidden');
    colSubMenu.find('.submenu:nth-of-type(' + menuItemIndex + ')').removeClass('hidden');
}

function hideNavMenus() {
    headerSection.removeClass('open');
    menuGuidesContainer.removeClass('in').addClass('hidden');
    menuOverlay.removeClass('in').addClass('hidden');
    if (isMobile) {
        colMenu.show();
        colSubMenu.addClass('hidden-sm hidden-xs');
        colSubMenu.find('.submenu').addClass('hidden');
        $('html, body').removeAttr('style');
    }
}

// Exit overlay

if ($('body').is('.main-home') || $('body').is('.form')) {
    var time = new Date().getTime();
    var exitOverlay1 = $('#exit-overlay-1');
    var exitOverlay2 = $('#exit-overlay-2');
    $(document).on('click', '.exit-overlay-section .exit-button', function () {
        if ($('body').is('.with-exit-overlay-1')) {
            exitOverlay1.addClass('hidden');
            window.dataLayer.push({
                'event': 'overlayClosed',
                'overlayType': 1
            });
            try {
                FS.event('Overlay Closed', {
                    completed: true,
                    overlay: 1
                });
            } catch (e) { }
        } else if ($('body').is('.with-exit-overlay-2')) {
            exitOverlay2.addClass('hidden');
            try {
                FS.event('Overlay Closed', {
                    completed: true,
                    overlay: 2
                });
            } catch (e) { }
        }
    });
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            if ($('body').is('.with-exit-overlay-1')) {
                exitOverlay1.addClass('hidden');
                window.dataLayer.push({
                    'event': 'overlayClosed',
                    'overlayType': 1
                });
                try {
                    FS.event('Overlay Closed', {
                        completed: true,
                        overlay: 1
                    });
                } catch (e) { }
            } else if ($('body').is('.with-exit-overlay-2')) {
                exitOverlay2.addClass('hidden');
                window.dataLayer.push({
                    'event': 'overlayClosed',
                    'overlayType': 2
                });
                try {
                    FS.event('Overlay Closed', {
                        completed: true,
                        overlay: 2
                    });
                } catch (e) { }
            }
        }
    });
    if (isMobile) {
        $(window).bind("touchstart click scroll onscroll", function () {
            time = new Date().getTime();
        });
        $(window).blur(function () {
            if ($('body').is('.with-exit-overlay-1')) {
                exitOverlay1.removeClass('hidden');
                try {
                    FS.event('Overlay Shown', {
                        completed: true,
                        overlay: 1
                    });
                } catch (e) { }
            } else if ($('body').is('.with-exit-overlay-2')) {
                exitOverlay2.removeClass('hidden');
                try {
                    FS.event('Overlay Shown', {
                        completed: true,
                        overlay: 2
                    });
                } catch (e) { }
            }
        });
    } else {
        $('body').mouseleave(function () {
            var cookieData = JSON.parse(getCookie(cookieName));
            cookieData = cookieData || {};
            cookieData.exitOverlayShown = cookieData.exitOverlayShown || false;
            if (cookieData.exitOverlayShown == false) {
                if ($('body').is('.with-exit-overlay-1')) {
                    exitOverlay1.removeClass('hidden');
                    window.dataLayer.push({
                        'event': 'overlayShown',
                        'overlay': 1
                    });
                    try {
                        FS.event('Overlay Shown', {
                            completed: true,
                            overlay: 1
                        });
                    } catch (e) { }
                } else if ($('body').is('.with-exit-overlay-2')) {
                    exitOverlay2.removeClass('hidden');
                    window.dataLayer.push({
                        'event': 'overlayShown',
                        'overlay': 2
                    });
                    try {
                        FS.event('Overlay Shown', {
                            completed: true,
                            overlay: 2
                        });
                    } catch (e) { }
                }
                updateCookie(cookieName, 'exitOverlayShown', true, expirySeconds);
            }
        });
        $(document.body).bind("mousemove click keypress", function () {
            time = new Date().getTime();
        });
    }
    $('.btn-check-your-chances').click(function () {
        window.dataLayer.push({
            'event': 'overlayInteract',
            'overlay': 1
        });
        try {
            FS.event('Button Clicked', {
                completed: true,
                overlay: 1
            });
        } catch (e) { }
    });
    $('.btn-send-email-reminder').click(function () {
        window.dataLayer.push({
            'event': 'overlayInteract',
            'overlay': 1
        });
        try {
            FS.event('Button Clicked', {
                completed: true,
                overlay: 2
            });
        } catch (e) { }
    });
    $('#Email').keyup(function () { resetFormField('Email', 'Email Address'); });
    $('.btn-send-email-reminder').click(function (e) {
        e.preventDefault();
        sendReminderEmail($('#send-reminder-form'));
    });
    showExitOverlayAfterDuration();
}

function showExitOverlayAfterDuration() {
    setInterval(function () {
        var cookieData = JSON.parse(getCookie(cookieName));
        cookieData = cookieData || {};
        cookieData.exitOverlayShown = cookieData.exitOverlayShown || false;
        if (cookieData.exitOverlayShown == false) {
            if (new Date().getTime() - time >= 20000) {
                if ($('body').is('#with-exit-overlay-1')) {
                    exitOverlay1.removeClass('hidden');
                    window.dataLayer.push({
                        'event': 'overlayShown',
                        'overlayType': 1
                    });
                    try {
                        FS.event('Overlay Shown', {
                            completed: true,
                            overlay: 1
                        });
                    } catch (e) { }
                } else if ($('body').is('.with-exit-overlay-2')) {
                    exitOverlay2.removeClass('hidden');
                    window.dataLayer.push({
                        'event': 'overlayShown',
                        'overlayType': 2
                    });
                    try {
                        FS.event('Overlay Shown', {
                            completed: true,
                            overlay: 2
                        });
                    } catch (e) { }
                }
                updateCookie(cookieName, 'exitOverlayShown', true, expirySeconds);
            }
        }
    }, 1000);
}

function resetFormField($id, $message) {
    $("#" + $id + "Label").removeClass('form-error');
    $("#" + $id + "Label").html($message);
}

function resetCalcField($id, $message) {
    $("#" + $id + "-label").removeClass('text-red');
    $("#" + $id + "-input").removeClass('border-red');
    $("#" + $id + "-label").html($message);
}

function sendReminderEmail($formName) {
    var data = $($formName).serialize();
    $.ajax({
        type: "POST",
        data: data,
        url: "/exit-overlay",
        success: function (data) {
            errorCount = data.errorCount;
            if (data.errorCount > 0) {
                errors = data;
                $.each(errors, function (key, value) {
                    firstValue = value.toString().split(',')[0];
                    $('#' + key + 'Label').html(firstValue);
                    $('#' + key + 'Label').addClass('form-error');
                    //$("#"+key).addClass('otf-fail');
                });
            } else {
                exitOverlay2.addClass('hidden');
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
        }
    });
}

// HOME PAGE LOGIC
if ($('body').is('.home')) {
    // Set vars
    window.la = window.la || $('[name=loan_amount]');
    window.trm = window.trm || $('[name=loan_term]');
    if ($('[name=apr_amount_calc]').length > 0) {
        window.apr = $('[name=apr_amount_calc]');
    }
    if (!$('[name=apr_amount_calc]').length > 0) {
        window.apr = window.config.rep_apr_vm;
    }
    $('#term_header').html(window.trm.val());
    if ($('body').is('.home') && $('body').is('.calc') && window.la.length > 0) {
        updateCookie(cookieName, 'la', window.la.val(), expirySeconds);
        updateCookie(cookieName, 'trm', window.trm.val(), expirySeconds);
        handleTermOrAmountValues(window.trm.val(), window.la.val());
        monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr.val());
    }
    if ($('body').is('.home') && !$('body').is('.calc') && window.la.length > 0) {
        updateCookie(cookieName, 'la', window.la.val(), expirySeconds);
        updateCookie(cookieName, 'trm', window.trm.val(), expirySeconds);
        handleTermOrAmountValues(window.trm.val(), window.la.val());
        monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr);
    }

    // Term buttons
    $(document).on('click', '.term-buttons .term-button', function (event) {
        var button = $(event.target);
        if (!button.is('.term-button')) {
            button = button.closest('.term-button');
        }
        var buttons = button.closest('.term-buttons').find('.term-button');
        if (button.is('.selected')) {
            // Do nothing
            return false;
        }
        if (button.is('.disabled')) {
            // Do nothing
            return false;
        }
        if (button.is('.term-btn-locked')) {
            // Do nothing
            return false;
        }
        // Deselect the other buttons
        buttons.removeClass('selected');
        button.addClass('selected');
        // Set the value
        window.trm.val(button.data('value'));
        updateCookie(cookieName, 'trm', button.data('value'), expirySeconds);
        window.amplitude.rangeSliderTermEvent(button.data('value') + ' months');
        $('#term_header').html(button.data('value'));
    });

    $(document).on('change', '[name=loanamount_term]', function (event) {
        var input = $(event.target);
        $('[name=term]').val(input.val());
    });

    $(document).on('change', '[name=loanamount_mobile]', function (event) {
        var input = $(event.currentTarget);
        changeLoanAmount(input);
    });

    $(document).on('change', '[name=cta-term]', function (event) {
        var input = $(event.target);
        updateCookie(cookieName, 'trm', input.val(), expirySeconds);
        var loanTerm = $('[name=loan_term]');
        loanTerm.val(input.val());
        if (loanTerm != '') {
            $('[name=cta-term]').addClass('otf-pass');
        }
    });

    $(document).on('change', '[name=cta-purpose]', function (event) {
        var input = $(event.target);
        updateCookie(cookieName, 'purpose', input.val(), expirySeconds);
        var ctaPurposeHidden = $('[name=cta-purpose-hidden]')
        ctaPurposeHidden.val(input.val());
        if (ctaPurposeHidden != '') {
            $('[name=cta-purpose]').addClass('otf-pass');
        }
    });

    $(document).on('blur', '[name=cta-amount]', function (event) {
        var input = $(event.target);
        var value = roundLoanAmount(input.val());
        roundLoanAmount(input.val());
        input.val(value);
        updateCookie(cookieName, 'la', input.val(), expirySeconds);
    });

    // $(document).ready(function() {
    setTimeout(function () {
        $('#home_amount_range_slider').rangeslider({
            polyfill: false,
            onInit: function () {
                var handleDisplay = $('<div class="handle-display">£' + withCommas(window.la.val()) + '</div>');
                handleDisplay.appendTo(this.$handle);
            },
            onSlide: function (pos, value) {
                // Format val and set the display
                $('.handle-display').text('£' + withCommas(value));
                window.la = window.la || $('[name=loan_amount]');
                if (value != window.la.val()) {
                    window.la.val(value).change();
                }
                if ($('body').is('.uk-loan-purpose')) {
                    var form = $('.cta-amount-picker-row');
                    formPageTermBlockout(form, value);
                }
            }
        });
        $('#home_amount_slider').addClass('in');
    }, 500);
    // });

    if ($('body').is('.uk-loan-purpose')) {
        var form = $('.cta-amount-picker-row');
        var value = $('[name=loan_amount]').val();
        formPageTermBlockout(form, value);
    }

    setTimeout(function () {
        $('#home_amount_range_slider_seo').rangeslider({
            polyfill: false,
            onInit: function () {
                var handleDisplay = $('<div class="handle-display-seo">£' + withCommas(window.la.val()) + '</div>');
                handleDisplay.appendTo(this.$handle);
            },
            onSlide: function (pos, value) {
                // Format val and set the display
                this.$handle.find('.handle-display-seo').text('£' + withCommas(value));
                window.la = window.la || $('[name=loan_amount]');
                if (value != window.la.val()) {
                    window.la.val(value).change();
                }
            }
        });
        $('#home_amount_slider_seo').addClass('in');
    }, 500);
}

if ($('body').is('.uk-loans, .uk-personal-loans')) {
    $('.numeric-only').numeric();
}

if ($('body').is('.facebook')) {
    // FAQ Accordion
    $(document).on('click', '.accordion .accordion-question', function (event) {
        $('#finance_accordion .accordion-question').toggleClass('active');
        $(this).toggleClass('active');
        $(this).find('.accordion-question-content-container').slideToggle();
    });
    // Wait for background image to load before animation
    var ctaWoman = $('.cta-woman');
    if (ctaWoman) {
        try {
            var src = ctaWoman.css('background-image');
            var url = src.match(/\((.*?)\)/)[1].replace(/('|")/g, '');
            var img = new Image();
            img.onload = function () {
                $('.cta-woman').addClass('slide-in-right');
            }
            img.src = url;
            if (img.complete) img.onload();
        } catch (error) { }
    }
    // Randomise Feefo reviews
    var reviews = [
        { review: "“It was really easy and quick 🙌🏼 Money on my account straight away 👌🏻”", date: "July 3rd 2019" },
        { review: "“Very fast service no complicated forms to fill in”", date: "May 24th 2019" },
        { review: "“Quick, easy and free no-obligation service I would recommend”", date: "June 30th 2019" },
        { review: "“Really easy to use service, quick payout and clear information”", date: "July 3rd 2019" },
        { review: "“Very helpful, friendly and professional! I felt at ease and well informed!”", date: "June 29th 2019" },
        { review: "“The application process was good and easy. Quick decision, convenient”", date: " June 29th 2019" },
        { review: "“Efficient staff and smooth process, highly recommend.”", date: "30th June 2019" },
        { review: "“The application process was good and easy. Quick decision, convenient.”", date: "30th June 2019" },
        { review: "“Very quick and easy to use and very helpful, thank you”", date: "June 28th 2019" },
        { review: "“Fast easy and good service. Thank you 👍😊 Happy with their service. 👍👍”", date: "July 15th 2019" }
    ];
    var shuffle = function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    };
    var showReviews = shuffle(reviews);
    $('.feefo-review-text-1').text(showReviews[0].review);
    $('.feefo-review-text-2').text(showReviews[1].review);
    $('.feefo-review-text-3').text(showReviews[2].review);
    $('.feefo-review-text-4').text(showReviews[3].review);
    $('.feefo-review-date-1').text(showReviews[0].date);
    $('.feefo-review-date-2').text(showReviews[1].date);
    $('.feefo-review-date-3').text(showReviews[2].date);
    $('.feefo-review-date-4').text(showReviews[3].date);
}

if ($('body').is('.uk-loan-purpose')) {
    var homePageSliderVal = $('#home_amount_range_slider');
    $('body.uk-loan-purpose .handle-display').text('£' + withCommas(homePageSliderVal.val()));
}

//Date.toLocaleDateString.js
(function (global) {
    "use strict";

    var dateFormatOverride = function (locale) {

        var formatGB = this.getDate() + "/" + (this.getMonth() + 1) + "/" + this.getFullYear();
        var formatUS = this.getMonth() + 1 + "/" + this.getDate() + "/" + this.getFullYear();

        var formattedDate = {
            "en-AU": formatGB,
            "en-CA": formatUS,
            "en-GB": formatGB,
            "en-IN": formatUS,
            "en-NZ": formatGB,
            "en-US": formatUS,
            "es-MX": formatGB,
        };

        return formattedDate[locale] || formattedDate['en-US'];
    };

    function toLocaleDateStringSupportsLocales() {
        try {
            new Date().toLocaleDateString("i");
        } catch (e) {
            return e.name === "RangeError";
        }
        return false;
    }

    if (!toLocaleDateStringSupportsLocales()) {
        Date.prototype.toLocaleDateString = dateFormatOverride;
    }

    Date.prototype.subtractDays = function (days) {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() - days);
    };

    global.dateFormatOverride = dateFormatOverride;
}(window));

// Disable force touch
document.addEventListener('webkitmouseforcewillbegin', function (event) {
    event.preventDefault();
});

// Setup AJAX
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {

    // Cookie popup
    setTimeout(function () {
        $('#cookie-popup').hide();
    }, 15000);

    $('.cookie-popup-close').click(function () {
        $('#cookie-popup').hide();
    });

    $('[name=loanamount]').data('prev-val', $('[name=loanamount]').val());

    $('#quick-check-apply-btn').click(function () {
        window.dataLayer.push({
            'event': 'form',
            'formType': 5
        });
    });

    $('.side-nav-link-container').click(function () {
        $('.side-nav').hide();
    });

    $('.cookie-popup-close').click(function () {
        $('#cookie-popup').hide();
    });

    setTimeout(function () {
        $('#cookie-popup').hide();
    }, 10000);

    // Currency
    $(document).on('keyup, focus', '.currency', function (event) {
        var value = $(event.currentTarget).val();
        $(event.currentTarget).closest('.form-field').toggleClass('currency-symbol', value != '');
    });
    // Menu smooth scrolling
    $(document).on('click', '.home #main_nav li a[href^="/#"]', function (event) {
        event.preventDefault();
        var target = $(event.currentTarget);
        var id = target.attr('href').split('#')[1];
        var section = $('#' + id);
        if (section.length === 1) {
            $('html, body').animate({
                scrollTop: section.offset().top
            }, 500);
        }
    });
    // iOS Selects
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
        // Fix select boxes on iOS
        $('select').addClass('ios-select'); // provide a class for iOS select box
        $('select[size]').removeAttr('size');
    }

    $(document).ready(function () {
        $('.lazy-bg').removeClass('lazy-bg');
        $(document).on('click', '.header-menu-icon-mobile', function (event) {
            var links = $('header .links');
            links.addClass('open');
            $('body, html').css('scroll', 'hidden');
        });
        $(document).on('click', 'header .links a, .header-menu-close-icon-mobile', function (event) {
            var links = $('header .links');
            links.removeClass('open');
            $('body, html').css('scroll', null);
        });
        if ($('body').is('.home')) {
            $('#home_amount_display').click(function (e) {
                var button = $(e.target);
                var selectWrapper = button.next('.select-picker-wrapper');
                selectWrapper.find('.modal').modal('show');
            });
            $('#home_amount_picker').on('show.bs.modal', function (event) {
                // Check for mobile/desktop
                $('.modal .modal-content').css('overflow-y', 'auto');
                $('.modal .modal-content').css('height', $(window).height() * 0.95).css('max-height', '485px');
                $('#home_amount_picker').find('[name=loan_amount]').picker();
            });
            $('#home_amount_picker').on('shown.bs.modal', function (event) {
                var select = $('#home_amount_picker').find('[name=loan_amount]');
                $('#home_amount_picker').find('[name=loan_amount]').picker('setValue', select.val());
            });
        }
    });


    $('.home [name=loan_amount]').change(function (event) {
        var value = $(event.currentTarget).val();
        $('#home_amount_display').html('<small>£</small>' + withCommas(value));
        $('#home_amount_display_seo').html('£' + withCommas(value));
        handleTermOrAmountValues(window.trm.val(), value);
        if ($('body').is('.home') && $('body').is('.calc')) {
            monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr.val());
        }
        if ($('body').is('.home') && !$('body').is('.calc')) {
            monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr);
        }
    });

    $('.home [name=loan_term]').change(function (event) {
        handleTermOrAmountValues(window.trm.val(), window.la.val());
        if ($('body').is('.home') && $('body').is('.calc')) {
            monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr.val());
        }
        if ($('body').is('.home') && !$('body').is('.calc')) {
            monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr);
        }
    });

    $('.home .term-button').on("click", function () {
        setTimeout(() => {
            $('#loan_term').trigger('change');
        }
            , 100);
    });

    $('.home [name=apr_amount_calc]').change(function (event) {
        if ($('body').is('.home') && $('body').is('.calc')) {
            monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr.val());
        }
        if ($('body').is('.home') && !$('body').is('.calc')) {
            monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr);
        }
    });

    $(document).on('show.bs.modal', '.modal-centre', function (event) {
        var modal = $(event.target);
        modal.css({
            'visibility': 'hidden',
            'display': 'block'
        });
        var height = modal.find('.modal-dialog').height();
        modal.css({
            'visibility': 'visible'
        });
        var windowHeight = window.innerHeight;
        if (windowHeight > height) {
            modal.css('top', (windowHeight - height) / 2);
        }
    });
    $(document).ready(function () {
        if (window.innerWidth <= 991 || $('body').hasClass('carLoan')) {
            $('.modal-picker').picker();
        }
        $('body').removeClass('no-anim');
    });

    $('[name=loanamount]').focus(function () {
        this.setSelectionRange(0, this.value.length);
    });


    $('.panel-heading').click(function () {
        $(this).find('i').toggleClass('glyphicon-minus glyphicon-plus');
    });


    $(document).on('click', '.mobile-summary-edit-button', function (event) {
        var button = $(event.target);
        var summary = button.closest('.mobile-section-1-summary');
        var display = summary.find('.mobile-section-1-summary-display');
        var edit = summary.find('.mobile-section-1-summary-edit');
        display.addClass('hidden');
        edit.removeClass('hidden');
    });
    // if ($('body').is('.main-home')) {
    //     $(window).scroll(function () {
    //         var btnOffset = $(".cta-main-container .cta-main-button").offset().top + 48;
    //         var scrollTop = $(window).scrollTop();
    //         if (scrollTop > btnOffset) {
    //             $("#main-cta-sticky-header").removeClass('hidden');
    //             setTimeout(function () {
    //                 $("#main-cta-sticky-header").addClass('in');
    //             }, 100);
    //             window.dataLayer.push({
    //                 'event': 'stickyShown',
    //                 'overlayType': 1
    //             });
    //             try {
    //                 FS.event('Sticky Shown', {
    //                     completed: true,
    //                     overlay: 1
    //                 });
    //             } catch (e) { }
    //         } else {
    //             $("#main-cta-sticky-header").removeClass('in').addClass('hidden');
    //         }
    //     });
    //     $(document).on('click', '#main-cta-sticky-header-btn', function (event) {
    //         window.dataLayer.push({
    //             'event': 'stickyButtonClicked',
    //             'overlayType': 1
    //         });
    //         try {
    //             FS.event('Sticky Button Clicked', {
    //                 completed: true,
    //                 overlay: 1
    //             });
    //         } catch (e) { }
    //     });
    // }
});

var bodyClassIntervalTries = 10;
var bodyClassInterval = setInterval(function () {
    if (bodyClassIntervalTries <= 0) {
        clearInterval(bodyClassInterval);
    }
    if ($('body').is('.with-email-suggestion') && typeof window.setupEmailSuggestion !== 'undefined') {
        window.setupEmailSuggestion();
        clearInterval(bodyClassInterval);
    }
    bodyClassIntervalTries--;
}, 1000);



$(document).ready(function () {
    function toggleInfo(buttonId, contentClass, textOpen, textClose) {
        $(buttonId).click(function () {
            $(contentClass).slideToggle(400, function () {
                if ($(this).is(":visible")) {
                    $(buttonId).text(textClose);
                } else {
                    $(buttonId).text(textOpen);
                }
            });
        });
    }

    toggleInfo("#more-info-calc", ".calc-info", "More info", "Hide more info");
    toggleInfo("#more-info-apr", ".calc-apr", "What's an APR interest rate?", "Hide what's an APR interest rate?");
});


function monthlyPaymentCalculationNew(loanAmount, termAmount, aprAmount) {
    var r = aprAmount / (12 * 100);
    var p = loanAmount;
    var m = (p * r * ((1 + r) ** termAmount) / (((1 + r) ** termAmount) - 1));
    window.totalRepayable = (m * termAmount).toFixed(2);
    window.totalInterest = (totalRepayable - loanAmount).toFixed(2);
    window.monthlyPaymentTwoDecimals = m.toFixed(2);
    $('#amount_header_calc').html(monthlyPaymentTwoDecimals);
    $('#dynamicLoanAmount').html('£' + loanAmount);
    $('.dynamicLoanTerm').html(termAmount);
    $('#dynamicMonthlyRepayment').html('£' + window.monthlyPaymentTwoDecimals);
    $('.dynamicTotalRepayment').html('£' + window.totalRepayable);
    $('.dynamicTotalInterest').html('£' + window.totalInterest);
    $('.dynamicInterestRate').html(aprAmount + '%');
}


$(document).ready(function () {
    $('#quote-email-input').keyup(function () { resetCalcField('quote-email', 'Email Address'); });
    $(".email-quote-btn").click(function (event) {
        window.dataLayer.push({
            'event': 'll_calculator_started',
            'll_calculator_status': 'started'
        });
    });
    $(".send-quote-btn").click(function (event) {
        event.preventDefault();
        monthlyPaymentCalculationNew(window.la.val(), window.trm.val(), window.apr.val());
        const email = $("input[type='email']").val();
        const consentText = $('#consent-box p').map(function () {
            return $(this).text();
        }).get().join(' ');
        $.ajax({
            url: "/calculator-quote",
            type: "POST",
            data: {
                "email": email,
                "loanAmount": window.la.val(),
                "loanTerm": window.trm.val(),
                "apr": window.apr.val(),
                "totalRepayable": totalRepayable,
                "totalInterest": totalInterest,
                "monthlyPaymentTwoDecimals": monthlyPaymentTwoDecimals,
                "consentText": consentText,
                "g-recaptcha-response": grecaptcha.getResponse(),
            },
            success: function (response) {
                // Handle success
                $('.calc-consent-modal').addClass('hidden');
                $('#quote-sent').removeClass('hidden');
                window.amplitude.calculatorSubmissionEvent('success');
                window.dataLayer.push({
                    'event': 'll_calculator_complete',
                    'll_calculator_status': 'success'
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var response = JSON.parse(jqXHR.responseText);
                if (jqXHR.status === 422 && response.email && response.email.length > 0) {
                    $('#quote-email-label').html(response.email).addClass('text-red');
                    $('#quote-email-input').addClass('border-red');
                    window.amplitude.calculatorSubmissionError(response.email);
                    window.dataLayer.push({
                        'event': 'll_calculator_complete',
                        'll_calculator_status': 'form error: email'
                    });
                }
                if (jqXHR.status === 422 && response['g-recaptcha-response'] && response['g-recaptcha-response'].length > 0) {
                    $('#g-recaptcha-responseLabel').html(response['g-recaptcha-response']).addClass('text-red');
                    window.amplitude.calculatorSubmissionError(response['g-recaptcha-response']);
                    window.dataLayer.push({
                        'event': 'll_calculator_complete',
                        'll_calculator_status': 'form error: captcha'
                    });
                }
                if (jqXHR.status !== 422) {
                    $('.calc-consent-modal').addClass('hidden');
                    $('#quote-error').removeClass('hidden');
                    window.amplitude.calculatorSubmissionError('500 - internal server error');
                    window.dataLayer.push({
                        'event': 'll_calculator_complete',
                        'll_calculator_status': 'server error'
                    });
                }
            }
        });
    });
});
